import Uiconstants from '../../lib/UIconstants';
import BonusWidgetController from '../../controllers/bonus/BonusWidgetController';
import { COMPONENTS } from '../../lib/constants';
import { isDesktop } from 'react-device-detect';

var pos = isDesktop ? { x: 170, y: -70 } : { x: 220, y: -20 };
var border_pos_top = isDesktop ? { x: -22, y: -22 } : { x: -22, y: -22 };
var scale = isDesktop ? { x: 1, y: 1 } : { x: 0.48, y: 0.48 };
var scaleScatter = isDesktop ? { x: 1, y: 1 } : { x: 1, y: 1 };

export const BonusBuyWidget = {
	name: COMPONENTS.BONUS_BUY_WIDGET,
	position: {
		x: 1410,
		y: 487
	},
	controllers: [
		{
			Controller: BonusWidgetController,
			name: Uiconstants.FTR_BONUS_BY,
			config: {
				item: COMPONENTS.BONUS_BUY_PAGE,
				modal: Uiconstants.FTR_BONUS_BY,
				border: 'bg'
			}
		}
	],
	components: [
		{
			name: 'holder',
			type: 'Sprite',
			position: { x: 0, y: 0 },
			components: [
				{
					name: Uiconstants.FTR_BONUS_BY,
					type: 'Button',
					components: [
						{
							name: 'bg',
							type: 'MouseOverSprite',
							img: 'bonus_buy_widget_bg',
							imgHover: 'bonus_buy_widget_bg_hovered',
							config: {
								hover: ['bg_border_top', 'bg_border_bot'],
								default: ['bg_border_top_passive', 'bg_border_bot_passive'],
								mobile: true
							},
							components: [
								isDesktop && {
									name: 'bg_border_top',
									type: 'AnimatedSprite',
									position: border_pos_top,
									animation: {
										pattern: 'orangemodalactive_000$.png',
										start: 0,
										end: 23,
										speed: 0.25,
										scale: scale,
										loop: true,
										precision: 2
									}
								},
								isDesktop && {
									name: 'bg_border_bot',
									type: 'AnimatedSprite',
									position: {
										x: -22,
										y: 93
									},
									animation: {
										pattern: 'orangemodalactive_000$.png',
										start: 0,
										end: 23,
										speed: 0.25,
										scale: scale,
										loop: true,
										precision: 2,
										rotation: 3.14159,
										anchor: {
											x: 1,
											y: 0.5
										}
									}
								},
								{
									name: 'bg_border_top_passive',
									type: 'AnimatedSprite',
									position: border_pos_top,
									animation: {
										pattern: 'orangemodal_000$.png',
										start: 0,
										end: 23,
										speed: 0.25,
										scale: scale,
										loop: true,
										precision: 2
									}
								},
								{
									name: 'bg_border_bot_passive',
									type: 'AnimatedSprite',
									position: {
										x: -22,
										y: 93
									},
									animation: {
										pattern: 'orangemodal_000$.png',
										start: 0,
										end: 23,
										speed: 0.25,
										scale: scale,
										loop: true,
										precision: 2,
										rotation: 3.14159,
										anchor: {
											x: 1,
											y: 0.5
										}
									}
								}
							]
						}
					]
				},
				isDesktop
					? {
							name: 'fg',
							type: 'AnimatedSprite',
							position: pos,
							animation: {
								pattern: 'BackgroundSpaceship$.png',
								start: 0,
								end: 58,
								speed: 0.25,
								scale: scaleScatter,
								loop: true,
								precision: 2
							}
						}
					: {
							name: 'fg',
							type: 'Sprite',
							img: 'bonus_img',
							position: pos
						},
				{
					name: 'BONUS_BUY_WIDGET_TITLE',
					type: 'Text',
					position: { x: 27, y: 23 },
					text: 'BONUS_BUY_TITLE'
				},
				{
					name: 'BONUS_BUY_VALUE',
					type: 'Text',
					position: { x: 27, y: 46 },
					text: 'BONUS_BUY_WIDGET_VALUE'
				}
			]
		}
	]
};
